module.exports = __webpack_public_path__ + "img/Eo8.fc30a03a.jpg";